import clsx from "clsx";

export const UiTextXs = ({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) => {
  return (
    <p className={clsx("text-xs leading-[1.125rem] text-gray-900", className)}>
      {text}
    </p>
  );
};
